import Config from "./config";
import AppState from "./view/AppState";
import NavbarView from "./view/NavbarView";
import "horizon-js-front-sdk/lib/xdomain.min.js";
import "fomantic/src/semantic.css";
import "fomantic/src/semantic.js";
import "./libs/HorizonCss/horizon.css";
import "font-awesome-sdk/src/V6/css/pro-v4-font-face.min.css";
import "font-awesome-sdk/src/V6/css/pro-v4-shims.min.css";
import "font-awesome-sdk/src/V6/css/pro.min.css";
import "jquery";
import "./libs/Polyfill/String";
import {Logger} from "horizon-js-front-sdk/lib/Logger";
import {DependencyInjector, DependencyInjectorInstance} from "horizon-js-front-sdk/lib/DependencyInjector";
import Vue from "vue";
// @ts-ignore
import Cleave from "vue-cleave-component";
import {Router} from "horizon-js-front-sdk/lib/Router";
import AuthenticationManager from "horizon-js-front-sdk/lib/AuthenticationManager";
import {SidebarView} from "./view/SidebarView";

//setting logger on info
Logger.level = Logger.INFO;
let injector: DependencyInjector = DependencyInjectorInstance();

let config: Config = new Config();
injector.register(Config, config);

function initApp() {
    injector.register(Config, config);
    let appState: AppState = new AppState();
    injector.register(AppState, appState);

    Vue.use(Cleave);

    let router = new Router('/pages/', {
        type: 'URL',
        config: {
            suffixes: ['.html'],
            prefix: '/',
            registerGlobalInterceptor: true
        }
    }, 'page');

    let uuidRegex = /([0-9a-f]{8}\-[0-9a-f]{4}\-[0-9a-f]{4}\-[0-9a-f]{4}\-[0-9a-f]{12})/;

    router.addRoute({location: 'auth', loader: () => import('./pages/auth')});
    router.addRoute({location: 'index', loader: () => import('./pages/index')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/?$/.source), loader: () => import('./pages/index')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/facturer\/?$/.source), loader: () => import('./pages/invoicing')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/factures\/?$/.source), loader: () => import('./pages/invoices')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/factures-achat\/?$/.source), loader: () => import('./pages/uploads')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/clients\/?$/.source), loader: () => import('./pages/customers')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/rapprochement\/?$/.source), loader: () => import('./pages/accounting')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/comptes\/?$/.source), loader: () => import('./pages/csvImport')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/produits\/?$/.source), loader: () => import('./pages/products')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/inventaires\/?$/.source), loader: () => import('./pages/inventories')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/inventaire\/?$/.source), loader: () => import('./pages/inventory')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/inventaire\//.source + uuidRegex.source + /\/valider\/?$/.source), loader: () => import('./pages/inventoryValidation')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/employes\/.*/.source), loader: () => import('./pages/employee')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/contrat\//.source + uuidRegex.source + /\/?$/.source), loader: () => import('./pages/contract')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/planning\/?$/.source), loader: () => import('./pages/calendar')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/objectifs\/?$/.source), loader: () => import('./pages/turnoverTargets')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/statistiques\/?$/.source), loader: () => import('./pages/stats')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/statistiques-produit\/?$/.source), loader: () => import('./pages/productStats')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/liens\/?$/.source), loader: () => import('./pages/productsMatching')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/templates\/?$/.source), loader: () => import('./pages/invoiceTemplates')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/categories-de-compte\/?$/.source), loader: () => import('./pages/accountingAccountCategories')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/produits-orphelins\/?$/.source), loader: () => import('./pages/orphans')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/pointeuse\/?$/.source), loader: () => import('./pages/timeClock')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/import-fournisseur\/?$/.source), loader: () => import('./pages/providerImport')});
    router.addRoute({regex: new RegExp(/etablissement\//.source + uuidRegex.source + /\/sepa-export\/?$/.source), loader: () => import('./pages/sepaExport')});

    DependencyInjectorInstance().register(Router, router);
    router.updateCurrentPageFromCurrentLocation();

    if(AuthenticationManager.isConnected()) {
        new NavbarView('#navbar');
        let sidebarView = new SidebarView('#sidebar');
        injector.register(SidebarView, sidebarView);
    } else {
        router.changePage('auth');
    }
}


if (!config.isValid()) {
    config.getFromServer().then(function (JSONConfig: any) {
        config = new Config(JSONConfig);
        let xDomainParameter: any = {};

        let plDomain = config.invoiceApi_serviceUrl;
        if (plDomain) {
            let nddWithoutSlashAtTheEnd: string = '';
            if (plDomain.charAt(plDomain.length - 1) === '/') {
                nddWithoutSlashAtTheEnd = plDomain.substring(0, plDomain.length - 1);
            }

            xDomainParameter[nddWithoutSlashAtTheEnd] = "/api/cors";
        }
        xdomain.slaves(xDomainParameter);

        let storedVersion = window.localStorage.getItem('version');
        if (storedVersion !== null) {
            if (storedVersion !== config.version) {
                window.localStorage.setItem('version', config.version);
                window.location.reload();
            }
        } else {
            window.localStorage.setItem('version', config.version);
        }
        initApp();
    }).catch(function (error) {
        console.log("Error : Index.ts | Detail : ", error);
    });
} else {
    initApp();
}











